import { useProjectStore } from '@core/store';

import classes from '../../style.module.scss';
import { categoryIcons } from '../../utils/categoryIconMap';

interface PageCategoryProps {
  appMeta: {
    title: string;
    type: string;
  };
  featureOptions: object;
}

const PageCategory = ({ appMeta, featureOptions }: PageCategoryProps) => {
  const [pageIconVisibility] = useProjectStore(s => [s.data.appearance.navigation.page_icons]);

  return (
    <div className={classes['Header-left-nav']}>
      {pageIconVisibility === 'enabled' && (
        <i aria-hidden="true" className={`${categoryIcons[appMeta?.type]} ${classes['Header-left-nav-icon']}`} />
      )}
      {featureOptions?.[appMeta?.type]}
      {appMeta?.type === 'custompage' && appMeta.title}
      {appMeta?.type === '404' && 'Page Not Found'}
    </div>
  );
};

export default PageCategory;
